/**
 * Guard for redirect/return-URL values that must stay same-origin.
 *
 * A safe internal path is a root-relative path (`/…`) that is NOT protocol-
 * relative (`//host` or the `/\host` variant some browsers normalize to `//`) —
 * both of which navigate off-site. Absolute URLs (`https://…`, `javascript:…`)
 * are rejected too. Used by the sign-in interstitial and `useAuth().signOut()`
 * so a crafted `returnUrl` can't bounce the flow to an attacker origin.
 */
export function isSafeInternalPath(value: unknown): value is string {
  return (
    typeof value === "string" &&
    value.startsWith("/") &&
    !value.startsWith("//") &&
    !value.startsWith("/\\")
  );
}

/**
 * Coerce a possibly-array query value (`route.query.x` is `string | string[]`)
 * to a safe internal path, falling back when it isn't one.
 */
export function safeInternalPath(raw: unknown, fallback: string): string {
  const value = Array.isArray(raw) ? raw[0] : raw;
  return isSafeInternalPath(value) ? value : fallback;
}
